import { Dictionaries_Types_Enum_Enum } from '@graphql/__generated__/graphql';

export const AGENT_DICTIONARY_FIELDS = [
  'languages',
  'certifications',
  'services',
] as const;

export type AgentDictionaryField = (typeof AGENT_DICTIONARY_FIELDS)[number];

const DICTIONARY_TYPE_BY_AGENT_FIELD = {
  languages: Dictionaries_Types_Enum_Enum.Languages,
  certifications: Dictionaries_Types_Enum_Enum.Certifications,
  services: Dictionaries_Types_Enum_Enum.Services,
} satisfies Record<AgentDictionaryField, Dictionaries_Types_Enum_Enum>;

export const getAgentDictionaryType = (
  field: AgentDictionaryField,
): Dictionaries_Types_Enum_Enum => DICTIONARY_TYPE_BY_AGENT_FIELD[field];
